import { createContext, useContext } from "react";

import { useAppToken } from "../hooks/api/useAppToken";

const AppTokenContext = createContext<string>("");

export function AppTokenProvider({ children }: { children: React.ReactNode }) {
  const { data } = useAppToken();

  const token = data || ""; // we are using react suspense and error boundaries, so data should always be defined when this component is rendered
  return <AppTokenContext.Provider value={token}>{children}</AppTokenContext.Provider>;
}

export function useProvidedAppToken() {
  const ctx = useContext(AppTokenContext);
  if (ctx === undefined) {
    throw new Error("useProvidedAppToken must be used within AppTokenProvider");
  }
  return ctx;
}
